import { RowCrudStatus } from "../../common/types";
import {
  Interpreter,
  InterpreterCreateMutationVariables,
  InterpreterUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";

export type InterpreterValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  createdAt_: Date | null;
  lastUpdatedAt_: Date | null;
};

export type InterpreterErrorsType = {
  name?: { message: string; fieldLabel: string };
};

export function InterpreterValuesInit(): InterpreterValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    createdAt_: null,
    lastUpdatedAt_: null,
  };
}

export type InterpreterType = Interpreter | InterpreterValuesType;

export function interpreterDisplayId(
  source: Partial<Interpreter>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getInterpreterValues(
  source: InterpreterType,
  _langStore: LangStore,
  _duplicated: boolean = false
): InterpreterValuesType {
  const entityValues = InterpreterValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : interpreterDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.createdAt_ = source.createdAt_
    ? new Date(source.createdAt_)
    : null;
  entityValues.lastUpdatedAt_ = source.lastUpdatedAt_
    ? new Date(source.lastUpdatedAt_)
    : null;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getInterpreterUpdateVariables(
  values: InterpreterValuesType
): InterpreterUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
  };
}

export function getInterpreterCreateVariables(
  values: InterpreterValuesType
): InterpreterCreateMutationVariables {
  return {
    name: values.name,
  };
}
